<template>
<div class="bcc-state">
  <div class="bcc-state__image">
    <template v-if="type==='custom'">
    <slot name="image"></slot>
    </template>
    <img src="//s1.hdslb.com/bfs/static/studio/static/bubble/state/empty.png"
         alt="empty" v-else-if="type==='empty'"/>
    <img src="//s1.hdslb.com/bfs/static/studio/static/bubble/state/empty.png"
         alt="empty" v-else/>
  </div>
  <p class="bcc-state__tip">{{tip}}</p>
  <div class="bcc-state__actions" v-if="actions">
    <bcc-button
        v-for="action of [].concat(actions)" :key="action.action"
        :type="action.type||'default'" size="large"
        @click="$emit(action.action)">{{action.title}}
    </bcc-button>
  </div>
</div>
</template>
<script>
import BccButton from '../button/button'

export default {
  name: 'BccState',
  componentName: 'BccState',
  components: { BccButton },
  props: {
    type: {
      type: String,
      required: true
    },
    tip: {
      type: String,
      required: true
    },
    actions: {
      type: [Array, Object],
      default: null
    }
  }
}
</script>
